import React from 'react';
import { observer } from 'mobx-react';
import ActionMenu from 'ats/components/action-menu/ActionMenu';
import { copyTextToClipboard } from 'ats/utils/copyToClipboard';
import { clientStore } from '../ClientStore';
import { notificationStore } from 'components/layout/notifications/NotificationStore';

function ClientContactsTable({ data, clientId, onSuccess }) {
	const renderTableHeader = () => (
		<thead>
			<tr>
				<th style={{ width: '40%' }}>Name</th>
				<th style={{ width: '40%' }}>Role</th>
				<th style={{ width: '20%' }}></th>
			</tr>
		</thead>
	);

	const handleTogglePrimary = async row => {
		try {
			const result = await clientStore.updateClientContact(clientId, row.id, {
				isPrimary: !row.isPrimary
			});

			if (result.status === 'success') {
				notificationStore.pushNotification({
					type: notificationStore.SUCCESS_NOTIFICATION,
					title: 'Update Contact',
					message: 'Primary contact has been updated.'
				});

				if (onSuccess) {
					onSuccess();
				}
			} else {
				notificationStore.pushNotification({
					type: notificationStore.ERROR_NOTIFICATION,
					title: 'Update Contact',
					message: 'An error has occurred. Please try again.'
				});
			}
		} catch (error) {
			console.error('Error updating primary contact:', error);
			notificationStore.pushNotification({
				type: notificationStore.ERROR_NOTIFICATION,
				title: 'Update Contact',
				message: 'An error has occurred. Please try again.'
			});
		}
	};

	const renderTableRow = row => {
		return (
			<tr key={row.id}>
				<td>
					<div className="name-column">
						<button
							className="set-primary-btn"
							title="Primary"
							onClick={e => {
								e.preventDefault();
								handleTogglePrimary(row);
							}}
							type="button"
							style={{
								background: 'none',
								border: 'none',
								padding: 0,
								cursor: 'pointer'
							}}>
							<img
								src={
									row.isPrimary
										? '/ats/icons/star-filled.svg'
										: '/ats/icons/star-empty.svg'
								}
								alt="Primary"
							/>
						</button>
						{row.name}
					</div>
				</td>
				<td>{row.role}</td>
				<td className="social-buttons-column">
					<div>
						{row.email ? (
							<ActionMenu
								buttonIcon={
									<img src="/ats/icons/email-2-icon.svg" alt="Email" />
								}
								tooltipText={row.email}
								items={[
									{
										label: 'Copy Email',
										img: '/ats/icons/copy-icon.svg',
										onClick: () => copyTextToClipboard(row.email),
										successLabel: 'Email Copied',
										successImg: '/ats/icons/check-icon.svg',
										resetDelay: 2000
									},
									{
										label: 'Send an Email',
										img: '/ats/icons/send-icon.svg',
										onClick: () => window.open(`mailto:${row.email}`, '_blank')
									}
								]}
							/>
						) : (
							<div className="social-inactive-icon is-flex is-justify-content-center">
								<img src="/ats/icons/email-2-inactive-icon.svg" alt="Email" />
							</div>
						)}
						{row.phone ? (
							<ActionMenu
								buttonIcon={
									<img src="/ats/icons/phone-2-icon.svg" alt="Phone" />
								}
								tooltipText={row.phone}
								items={[
									{
										label: 'Copy Phone number',
										img: '/ats/icons/copy-icon.svg',
										onClick: () => copyTextToClipboard(row.phone),
										successLabel: 'Phone Copied',
										successImg: '/ats/icons/check-icon.svg',
										resetDelay: 2000
									},
									{
										label: 'Make a Phone call',
										img: '/ats/icons/send-icon.svg',
										onClick: () => window.open(`tel:${row.phone}`, '_blank')
									}
								]}
							/>
						) : (
							<div className="social-inactive-icon is-flex is-justify-content-center">
								<img src="/ats/icons/phone-2-inactive-icon.svg" alt="Phone" />
							</div>
						)}
						{row.slackId ? (
							<ActionMenu
								buttonIcon={<img src="/ats/icons/slack-icon.svg" alt="Slack" />}
								tooltipText={row.slackId}
								items={[
									{
										label: 'Copy Slack ID',
										img: '/ats/icons/copy-icon.svg',
										onClick: () => copyTextToClipboard(row.slackId),
										successLabel: 'Slack ID Copied',
										successImg: '/ats/icons/check-icon.svg',
										resetDelay: 2000
									},
									{
										label: 'Send Slack message',
										img: '/ats/icons/send-icon.svg',
										onClick: () =>
											window.open(
												`https://slack.com/app_redirect?channel=${row.slackId}`,
												'_blank'
											)
									}
								]}
							/>
						) : (
							<div className="social-inactive-icon is-flex is-justify-content-center">
								<img src="/ats/icons/slack-inactive-icon.svg" alt="Slack" />
							</div>
						)}
					</div>
				</td>
			</tr>
		);
	};

	return (
		<table className="table is-fullwidth">
			{renderTableHeader()}
			<tbody>{data.map(renderTableRow)}</tbody>
		</table>
	);
}

export default observer(ClientContactsTable);
